// extracted by mini-css-extract-plugin
export default {"questions":"_2822dcba","buttons":"_df90c122","requestPrice":"_c0948b7b"};